import { cn as e } from "../utils/index.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/typography.tsx
var n = {
	h1: "text-[38px]/[46px] font-medium",
	h2: "text-[32px]/[40px] font-medium",
	h3: "text-[24px]/[32px] font-semibold",
	h4: "text-[20px]/[28px] font-semibold",
	p: "font-short-14",
	span: ""
};
function r({ variant: r = "span", className: i, children: a, ...o }) {
	return /* @__PURE__ */ t(r, {
		className: e(n[r], i),
		...o,
		children: a
	});
}
//#endregion
export { r as Typography };
